import { useEffect, useState } from "react";
import { getAuthTag } from "../services/userService";

interface IuseFetchAuthTag {
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

const useFetchAuthTag = ({ setIsLoading }: IuseFetchAuthTag) => {
  const [authTagData, setAuthTagData] = useState<any[]>([]);

  useEffect(() => {
    setIsLoading(true);
    const getAuthTagData = async () => {
      try {
        const res = await getAuthTag();
        setAuthTagData(res);
      } catch (err) {
        setAuthTagData([]);
      } finally {
        setIsLoading(false);
      }
    };
    getAuthTagData();
  }, []); // ✅ Removed setIsLoading to prevent infinite loops

  return [authTagData];
};

export default useFetchAuthTag;
